import EvolokActions from './EvolokActions'
let instance

export function getEvolokActions(user) {
  console.log('getEvolokActions called with user:', user)
  if (!instance) {
    instance = new EvolokActions(user)

    instance.init()
  }

  return instance
}
